import { Box, Collapse, Flex, Text } from '@chakra-ui/react'
import { objectToArray } from '@hb/shared'
import { JSX, useMemo, useState } from 'react'
import { useProfile } from '../../../../../../contexts/user/ProfileContext'
import { BasicPregnancyPreview } from '../../../../../Assessments/AssessmentPreview'
import { ViewMoreButton } from '../../../../../Buttons/ViewMoreButton'
import { PatientPregnancySummary } from '../../../Patient/PatientPregnancySummary'

const MorePregnanciesSummary = () => {
  const { selectedAssessment, assessments, mostRecentPregnancy, goTo } = useProfile()

  const [viewingMore, setViewingMore] = useState(false)
  const nonSelectedAssessments = useMemo(() => {
    const displayedAssessmentId = selectedAssessment?.id ?? mostRecentPregnancy?.id
    return objectToArray(assessments ?? {}).filter(a => a.id !== displayedAssessmentId)
  }, [assessments, mostRecentPregnancy, selectedAssessment])
  let body: JSX.Element | null = null
  if (nonSelectedAssessments.length) {
    body = (
      <>
        <Flex px={2} py={1} w="100%">
          <Text color="gray.600">
            {nonSelectedAssessments.length} other{' '}
            {nonSelectedAssessments.length === 1 ? 'pregnancy' : 'pregnancies'}
          </Text>
          <ViewMoreButton onClick={() => setViewingMore(!viewingMore)}>
            {!viewingMore ? '+ View All' : '- Collapse'}
          </ViewMoreButton>
        </Flex>
        <Collapse in={viewingMore} style={{ width: '100%' }}>
          <Flex flexFlow="column" gap={1.5} p={1} w="100%">
            {nonSelectedAssessments.map(assessment => (
              <BasicPregnancyPreview
                onSelect={() =>
                  goTo({ entity: { id: assessment.id, type: 'pregnancy' }, tab: null })
                }
                key={assessment.id}
                pregnancy={assessment}
              />
            ))}
          </Flex>
        </Collapse>
      </>
    )
  } else {
    body = (
      <Text
        w="100%"
        textAlign="center"
        fontFamily="Open Sans"
        px={2}
        color="gray.600"
        fontSize="md">
        No other pregnancies
      </Text>
    )
  }
  return (
    <Box pt={0.5} pb={1} w="100%" borderTop="1px solid #00000011">
      {body}
    </Box>
  )
}
export const PatientInfoPregnancySummary = () => (
  <Flex px={2} flexFlow="column" alignItems="center" w="100%">
    <PatientPregnancySummary />
    <MorePregnanciesSummary />
  </Flex>
)
